import React from "react";
import PropTypes from "prop-types";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useClassName } from "@travpro/hooks";
import i18n from "i18n-react";

import { useSearch } from "hooks/useSearch";

/**
 * An input component that opens the search modal when submitted.
 *
 * @returns {JSX.Element} The search input component
 */
const SearchInput = () => {
  const { showSearch, query } = useSearch();

  const c = useClassName("search");

  const handleSearch = (e) => {
    e.preventDefault();
    showSearch(query);
  };

  return (
    <div {...c()}>
      <div {...c("container")}>
        <button type="button" {...c("button")} onClick={handleSearch}>
          <FontAwesomeIcon icon={["far", "search"]} />
          <p>Search</p>
        </button>
      </div>
    </div>
  );
};

export default SearchInput;
